import { getQueryStringParameterByName } from './apiHelpers';
import { VITE_MOCK_API, VITE_AUTH_API } from 'Constants/appEnvConstants'

export default function getReportsBaseUrl() {
  // eslint-disable-next-line no-undef
  return getQueryStringParameterByName('useMockApi') ? VITE_MOCK_API : VITE_AUTH_API;
}
